import { createAction, type QueuedAction } from "@/v2/hooks/useActionQueue";
import { apiCall, type ActionDeps } from "./types";

export function combineAction(
	ids: number[],
	matterId: string,
	mainEntryId: number,
	deps: ActionDeps,
): QueuedAction {
	const nonMainIds = new Set(ids.filter((id) => id !== mainEntryId));
	const rollback = deps.updateEntries((prev) =>
		prev.filter((e) => !nonMainIds.has(e.id)),
	);

	return createAction({
		execute: () =>
			apiCall(deps, {
				endpoint: "/records/combine",
				method: "POST",
				body: { ids, matter_id: matterId, main_entry_id: mainEntryId },
			}),
		rollback,
		toast: {
			loading: `Combining ${ids.length} entries…`,
			success: `Combined ${ids.length} entries`,
			error: "Failed to combine entries",
		},
		onSuccess: () => deps.refreshRecords(),
		onError: () => deps.refreshRecords(),
	});
}
